import React, { Component } from 'react';
import { connect } from 'react-redux';
import { doRefreshRolesAndPermissions, setPage, doGetAllPermissionsList, doGetRoleList } from 'redux/actions';
import { RoleConfigModal } from 'components/features/RoleConfig/RoleConfigModal/RoleConfigModal';
import './UserPage.css';

class UserPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRoleDetailsOpen: false,
      roles: null,
      allServicePermissions: null,
      targetRoleId: null,
      errorMessage: null
    };
  }

  componentDidMount() {
    this.props.dispatch(setPage('UserPage'));
    this.props.dispatch(doRefreshRolesAndPermissions());

    this.props.dispatch(
      doGetRoleList(
        (result) => {
          this.setState({ roles: result });
        },
        (error) => {
          this.setState({ errorMessage: error });
        }
      )
    );

    this.props.dispatch(
      doGetAllPermissionsList(
        (result) => {
          this.setState({ allServicePermissions: result });
        },
        (error) => {
          this.setState({ errorMessage: error });
        }
      )
    );
  }

  componentDidUpdate() {
    if (this.state.roles && this.state.targetRoleId && this.state.currRoleData == null) {
      let foundRole = this.state.roles.find((r) => r.role === this.state.targetRoleId);
      this.setState({ currRoleData: foundRole });
    }
  }

  render() {
    if (!this.props.user) {
      return null;
    }

    return (
      <div className="UserPage pageStyle">
        {this.state.isRoleDetailsOpen && (
          <RoleConfigModal
            sourcePage={'usersPage'}
            editMode={'READONLY'}
            allServicePermissions={this.state.allServicePermissions}
            currRoleData={this.state.currRoleData}
            sendRoleConfigModalMode={(value) => value == null && this.setState({ isRoleDetailsOpen: false })}
          />
        )}

        <div className="UserPage_Title">User Profile</div>
        <div className="UserPage_Info">
          <div className="UserPage_Info_Body">
            <div className="UserPage_Info_Picture_Row">
              <div className="UserPage_Info_Picture_Value">
                <img src={this.props.user.picture} alt="" />
              </div>
            </div>
            <div className="UserPage_Info_Name_Row">
              <div className="UserPage_Info_Name_Header">Name</div>
              <div className="UserPage_Info_Name_Value">{this.props.user.nickname}</div>
            </div>
            <div className="UserPage_Info_Email_Row">
              <div className="UserPage_Info_Email_Header">Email</div>
              <div className="UserPage_Info_Email_Value">{this.props.user.name}</div>
            </div>
            <div className="UserPage_Info_Permissions_Row">
              <div className="UserPage_Info_Permissions_Header">Assigned Roles</div>
              <div className="UserPage_Info_Permissions_Value">
                {this.props.rolePermissions?.roles &&
                  this.props.rolePermissions.roles
                    .map((rp) => rp.role)
                    .map((p) => {
                      return (
                        <div
                          className="UserPage_Info_Permissions_Value_Permission"
                          data-tip={'Role Details'}
                          onClick={() => {
                            this.setState({ isRoleDetailsOpen: true, targetRoleId: p });
                          }}
                        >
                          {p}
                        </div>
                      );
                    })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((store) => {
  return {
    user: store.data.user,
    rolePermissions: store.data.rolePermissions
  };
})(UserPage);
